var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "table-responsive-lg",
        attrs: { striped: "", items: _vm.files, fields: _vm.fields },
        scopedSlots: _vm._u([
          {
            key: "head(link)",
            fn: function (data) {
              return [
                _c("span", {
                  staticClass: "fs-xl text-center",
                  domProps: { innerHTML: _vm._s(data.label) },
                }),
              ]
            },
          },
          {
            key: "cell(link)",
            fn: function (data) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "get_file cursor-pointer",
                    on: {
                      click: function ($event) {
                        return _vm.get_file(data.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-save save_me" })]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }